<script lang="ts">
  interface Props {
    character: string
    inline?: boolean
  }

  let { character, inline = false }: Props = $props()

  let cdnUrl = $derived(
    `https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/svg/${character
      ?.codePointAt(0)
      ?.toString(16)}.svg`,
  )
</script>

<!-- @component

  Display an emoji from the twemoji library.

  ```svelte
  <Emoji character="🎉" />
  ```
-->

<img class:inline src={cdnUrl} alt={character} />

<style lang="postcss">
  img {
    display: block;
    position: relative;
    &.inline {
      aspect-ratio: 1;
      height: 1em;
    }
  }
</style>
